import accounting from 'accounting';
import i18next from 'i18next';
import currencySymbolMap from './variables';
//import { getSymbolFromCurrency } from '~helpers/currency';

export const defaultCurrencyCode = 'USD';
export const currencySymbols = {
  ALL: 'ALL',
  AFN: 'AFN',
  ARS: 'ARS',
  AWG: 'AWG',
  AUD: 'A$',
  AZN: 'AZN',
  BSD: 'BSD',
  BBD: 'BBD',
  BYR: 'BYR',
  BZD: 'BZD',
  BMD: 'BMD',
  BOB: 'BOB',
  BAM: 'BAM',
  BWP: 'BWP',
  BGN: 'BGN',
  BRL: 'R$',
  BND: 'BND',
  KHR: 'KHR',
  CAD: 'CA$',
  KYD: 'KYD',
  CLP: 'CLP',
  CNY: 'CN¥',
  COP: 'COP',
  CRC: 'CRC',
  HRK: 'HRK',
  CUP: 'CUP',
  CZK: 'CZK',
  DKK: 'DKK',
  DOP: 'DOP',
  XCD: 'EC$',
  EGP: 'EGP',
  SVC: 'SVC',
  EEK: 'EEK',
  EUR: '€',
  FKP: 'FKP',
  FJD: 'FJD',
  GHC: 'GHC',
  GIP: 'GIP',
  GTQ: 'GTQ',
  GGP: 'GGP',
  GYD: 'GYD',
  HNL: 'HNL',
  HKD: 'HK$',
  HUF: 'HUF',
  ISK: 'ISK',
  INR: '₹',
  IDR: 'IDR',
  IRR: 'IRR',
  IMP: 'IMP',
  ILS: '₪',
  JMD: 'JMD',
  JPY: 'JP¥',
  JEP: 'JEP',
  KES: 'KES',
  KZT: 'KZT',
  KPW: 'KPW',
  KRW: '₩',
  KGS: 'KGS',
  LAK: 'LAK',
  LVL: 'LVL',
  LBP: 'LBP',
  LRD: 'LRD',
  LTL: 'LTL',
  MKD: 'MKD',
  MYR: 'MYR',
  MUR: 'MUR',
  MXN: 'MX$',
  MNT: 'MNT',
  MZN: 'MZN',
  NAD: 'NAD',
  NPR: 'NPR',
  ANG: 'ANG',
  NZD: 'NZ$',
  NIO: 'NIO',
  NGN: 'NGN',
  NOK: 'NOK',
  OMR: 'OMR',
  PKR: 'PKR',
  PAB: 'PAB',
  PYG: 'PYG',
  PEN: 'PEN',
  PHP: 'PHP',
  PLN: 'PLN',
  QAR: 'QAR',
  RON: 'RON',
  RUB: 'RUB',
  RMB: 'RMB',
  SHP: 'SHP',
  SAR: 'SAR',
  RSD: 'RSD',
  SCR: 'SCR',
  SGD: 'SGD',
  SBD: 'SBD',
  SOS: 'SOS',
  ZAR: 'ZAR',
  LKR: 'LKR',
  SEK: 'SEK',
  CHF: 'CHF',
  SRD: 'SRD',
  SYP: 'SYP',
  TZS: 'TZS',
  TWD: 'NT$',
  THB: '฿',
  TTD: 'TTD',
  TRY: 'TRY',
  TRL: 'TRL',
  TVD: 'TVD',
  UGX: 'UGX',
  UAH: 'UAH',
  GBP: '£',
  USD: '$',
  UYU: 'UYU',
  UZS: 'UZS',
  VEF: 'VEF',
  VND: '₫',
  YER: 'YER',
  ZWD: 'ZWD',
  GEL: 'GEL',
  AED: 'AED',
};
export const currencies = [
  { code: 'AED', label: 'AED (د.إ)' },
  { code: 'AFN', label: 'AFN (؋)' },
  { code: 'AUD', label: 'AUD ($)' },
  { code: 'CAD', label: 'CAD ($)' },
  { code: 'CNY', label: 'CNY (¥)' },
  { code: 'EUR', label: 'EUR (€)' },
  { code: 'GBP', label: 'GBP (£)' },
  { code: 'HKD', label: 'HKD ($)' },
  { code: 'JPY', label: 'JPY (¥)' },
  { code: 'KRW', label: 'KRW (₩)' },
  { code: 'MXN', label: 'MXN ($)' },
  { code: 'NZD', label: 'NZD ($)' },
  { code: 'PLN', label: 'PLN (zł)' },
  { code: 'USD', label: 'USD ($)' },
  { code: 'ZAR', label: 'ZAR (R)' },
];

export const localeToCurrencyMapping = {
  'en-gb': 'GBP',
  'en-us': 'USD',
  'zh-cn': 'CNY',
  'zh-tw': 'USD',
  'zh-hk': 'HKD',
  'ko-kr': 'KRW',
  'ja-jp': 'JPY',
  'de-de': 'EUR',
  'el-gr': 'EUR',
  'el-cy': 'EUR',
  'es-es': 'EUR',
  'es-la': 'MXN',
  'fr-fr': 'EUR',
  'it-it': 'EUR',
};

export function getSymbolFromCurrency(currencyCode) {
  if (typeof currencyCode !== 'string') {
    return null;
  }
  return currencySymbolMap[currencyCode.toUpperCase()] || currencyCode.toUpperCase();
}

const formatPrice = (price, currencyCode) => {
  if (price === null) {
    return null;
  }

  return accounting.formatMoney(price, {
    symbol: getSymbolFromCurrency(currencyCode),
    thousand: i18next.t('cms.currency.thousand_symbol'),
    format: i18next.t('cms.currency.symbol_value_order'),
  });
};

const customFormatPrice = (price, currencyCode, customFormatOptions) => {
  if (!customFormatOptions) {
    return formatPrice(price, currencyCode);
  } else {
    return accounting.formatMoney(price, {
      symbol: getSymbolFromCurrency(currencyCode),
      thousand: i18next.t('cms.currency.thousand_symbol'),
      format: i18next.t('cms.currency.symbol_value_order'),
      ...customFormatOptions,
    });
  }
};

export const formatPriceWithNoSymbol = (price, currencyCode) => {
  return customFormatPrice(price, currencyCode, {
    format: '%v',
  });
};

export const formatPriceWithSpace = (price, currencyCode) => {
  return customFormatPrice(price, currencyCode, {
    /*
    Attention:
    use i18next get the format string is not work. because i18next parse this into {{value}}v, in fact you will get `v`.
    */
    format: '%s %v',
  });
};

export default formatPrice;
